<template>
    <div id="second-tab-bar">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "SecondTarBar",
};
</script>

<style scoped>
#second-tab-bar{
    width: 100%;
}
</style>
